export default "640px"